import script from "./CustomListForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomListForm.vue?vue&type=script&setup=true&lang=ts"

import "./CustomListForm.vue?vue&type=style&index=0&id=58ac77bc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58ac77bc"]])

export default __exports__